<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
        <div class="cloud_top_banners">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="trinka_cloud_banner_text dropdown">
                            <h1>Microsoft Word（Mac版）用<br/>
                                Trinkaアドインで、<br/>
                                Trinkaをより身近に
                                <span>プレミアムプラン限定</span>
                            </h1>
                            <p>Trinkaが、Mac版Microsoft Word上で、あなたの書いた文章を自動的にチェックし、修正します。Trinka（トリンカ）のパワフルな機能をMacでも。</p>
                            <!-- <a id="TrinkaCloudGetStarted" [routerLink]="['/pricing']" routerLinkActive="active">Get it now</a> -->
                            <div id="MacMSWordButton">
                                <a (click)="scroll(target)" class="link">今すぐ入手する</a>
                                <div class="wordPluginCTA" id="MSWindowDownloadButton">
                                    <i class="">Beta</i>
                                </div>
                            </div>
                            
                            <!-- <b id="windowInfo32bit"></b> -->
                            <!-- <a id="wordPluginDownloadPopup" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Download Now <i class="fa fa-caret-down" aria-hidden="true"></i></a> -->
                            <!-- <span id="MSWindowTextContent">*Works on Microsoft Word 2010 and above on Windows</span> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="trinka_cloud_banner_img">
                            <img src="assets/images/MSWordBanner.png" alt="ms word - 文法 チェック">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="advanceGrammerSpellCheck_section publishEnhancements_slider accomplishSections">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6">
                        <div class="accomplishSections_img">
    
                            <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                                <img src="assets/images/microsoft-wordThumbnails.jpg" alt="" class="img-fluid eposter-img">
                            </a>
                        </div>
                    </div>
    
                    <div class="col-xl-6">
                        <div class="spellcheck_heading EnhancementsHeadingSection">
                            <h2>
                                Get started with the Trinka Add-in for Word on Windows
                            </h2>
                            <div class="HeadingSubLine"></div>
                            <p>Need help installing or want to know how to make corrections using the add-in?
                            </p>
                            <p>Check out the easy walk-through video to get started in no time.
                            </p>
                            <p>Have more questions? Browse through our FAQs <a (click)="scroll(target)" class="link">here</a>.
                            </p>
    
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="how_it_work_section">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="how_it_work_content">
                            <div class="howItWorkHeading">
                                <h2>使い方はとっても<br/>
                                    シンプル</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                            <ul>
                                <li>
                                    <div class="login_circle_section">
                                        <img src="assets/images/DownloadTrackChangesEdit.svg" width="50" alt="ダウンロード - 英文校正">
                                    </div>
                                    <h3>ダウンロード</h3>
                                </li>
                                <li>
                                    <div class="login_circle_section">
                                        <img src="assets/images/TypeOrImportFile_icon.png" alt="インストール - 英文チ ェッカー">
                                    </div>
                                    <h3>インストール</h3>
                                </li>
                                <li>
                                    <div class="login_circle_section">
                                        <img src="assets/images/WordCountreductions.png" alt="Macで校正スタート - ai英文校正">
                                    </div>
                                    <h3>Macで校正スタート！</h3>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="cloud_key_features">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="key_features_heading">
                            <h2>Mac版MS Word用Trinkaアドインの機能</h2>
                            <div class="HeadingSubLine"></div>
                            <p>Mac版MS Word用Trinkaアドインをインストールすると、いつも使い慣れたWordで英文を書きながらリアルタイムで専門的な修正提案を受けることができるようになります。英語論文執筆にとても便利な機能を紹介します。</p>
                        </div>
                    </div>
                </div>
                <div class="row match-box">
                    <div class="col-lg-4 col-md-6 dflex">
                        <div class="features_cards c-card">
                            <img src="assets/images/style_guide_icon.svg" alt="スタイルガイドに合わせた校正 - 英文校正">
                            <h3>スタイルガイドに合わせた校正</h3>
                            <p>スタイルガイドに合わせた文法、表記ルール、語彙等の校正を行います（AMA 11thまたはAGU 2017）。</p>
                        </div>
                    </div>
    
                    <div class="col-lg-4 col-md-6 dflex">
                        <div class="features_cards c-card">
                            <img src="assets/images/AddtoDictionary.svg" alt="マイ・ディクショナリー - 英文校正 ai" />
                            <h3>マイ・ディクショナリー</h3>
                            <p>マイ・ディクショナリーに用語を追加すれば、Trinkaがそれをスペルミスと判断することはなくなります。</p>
                        </div>
                    </div>
    
                    <div class="col-lg-4 col-md-6 dflex">
                        <div class="features_cards c-card">
                            <img src="assets/images/DataSecurityIcon.svg" alt="安心のデータセキュリティ - 文法 チェック">
                            <h3>安心のデータセキュリティ</h3>
                            <p>入力中の英文は厳重なセキュリティのもと送信、リアルタイムで分析され、Trinkaのサーバーに保存されることはありません。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="wordBlog" #target>
            <div class="container">
                <div class="row">
                    <div class="col-md-5 col-lg-5">
                        <div class="key_features_heading">
                            <h2>Mac版MS Word用Trinkaアドインの
                                インストール方法</h2>
                            <div class="HeadingSubLine"></div>
                            <p>すでにTrinkaプレミアムプランをご利用の場合、TrinkaのMac版MS Word用Trinkaアドインをインストール後すぐにご利用開始いただけます。ベーシックプランをご利用中の方は、ぜひこの機会にプレミアムプランへのアップグレードをご検討ください。
                            </p>
                        </div>
                    </div>
                    <div class="col-md-8 col-lg-6 offset-lg-1">
                        <div class="owl-carousel owl-theme" id="macWordSlider">
                            <div class="item">
                                <div class="wordCarousel">
                                    <div class="word-sm-title">
                                        <h2>ステップ1</h2>
                                        <div class="HeadingSubLine"></div>
                                    </div>
                                    <div class="media">
                                        <div class="media-body">
                                            <p>Wordを開き、メインメニューの「挿入」をクリックします。次に「アドインを入手」の「ストア」をクリックします。</p>
                                        </div>
                                    </div>
                                    <div class="wordImg">
                                        <img src="assets/images/step1AA.png" class="img-fluid" alt="Wordを開き - ai英文校正" />
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="wordCarousel">
                                    <div class="word-sm-title">
                                        <h2>ステップ2</h2>
                                        <div class="HeadingSubLine"></div>
                                    </div>
                                    <div class="media">
                                        <div class="media-body">
                                            <p>ウィンドウの左側にある検索バーに「Trinka」と入力してTrinkaアドインを確認し「追加」、「続行」をクリックします。 </p>
                                        </div>
                                    </div>
                
                                    <div class="wordImg">
                                        <img src="assets/images/step2.png" class="img-fluid" alt="ステップ2 - 英文校正" />
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="wordCarousel">
                                    <div class="word-sm-title">
                                        <h2>ステップ3</h2>
                                        <div class="HeadingSubLine"></div>
                                    </div>
                                    <div class="media">
                                        <div class="media-body">
                                            <p>Trinkaを使い始めるには、Wordのメニューバーに追加されたTrinkaタブをクリックして「Open Trinka」をクリック、Trinkaプレミアムアカウントへのログイン情報を入力して「LOG IN」を押してください。これで設定は完了です。</p>
                                        </div>
                                    </div>
                
                                    <div class="wordImg">
                                        <img src="assets/images/step4.png" class="img-fluid" alt="ステップ3 - 文法 チェック" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
    
    <!-- <section class="wordBlog">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <h3>How to Install the Trinka Word Add-In for Mac?</h3>
                    <p class="mb-40">Getting started with Trinka Grammar Checker Word Add-In on MAC is fast and simple. If you already have a Premium account than it is a good news that, Mac Word Add-In is included in your subscription. If you are a free user, you can upgrade to Premium to get access to this plugin, as well as many more features.</p>
                    <div class="word-sm-title">
                        <h2>Step 1</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="media">
                        <div class="media-body">
                            <p>Open Word and click "Insert" on the main menu. Then click on "Store ,"</p>
                        </div>
                    </div>

                    <div class="wordImg">
                        <img src="assets/images/step1AA.png" class="img-fluid" alt="step 1" />
                    </div>
                    <div class="word-sm-title">
                        <h2>Step 2</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="media">
                        <div class="media-body">
                            <p>Find the search bar on the left side of the window and then type " Trinka " to locate the Add-In. Click "Add" and then click "Continue." </p>
                        </div>
                    </div>

                    <div class="wordImg">
                        <img src="assets/images/step2.png" class="img-fluid" alt="step 1" />
                    </div>

                    <div class="word-sm-title">
                        <h2>Step 3</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="media">
                        <div class="media-left">
                            <div class="stepper">
                                <span>STEP</span>
                                <span>03</span>
                            </div>
                        </div>
                        <div class="media-body">
                            <p>Once successfully installed in Word, you'll see a message confirming successful installation of Trinka MS-Word Add-in.  </p>
                        </div>
                    </div>

                    <div class="wordImg">
                        <img src="assets/images/step3.png" class="img-fluid" alt="step 1" />
                    </div>

                    <div class="word-sm-title">
                        <h2>Step 4</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="media">
                        <div class="media-body">
                            <p>To get grammar corrections from Trinka, click on Trinka Tab on the Ribbon and click on “Open Trinka”   and log in to your Trinka Premium account and then hit "Login". You're now set to use the Trinka Word Add-In for Mac!</p>
                        </div>
                    </div>

                    <div class="wordImg">
                        <img src="assets/images/step4.png" class="img-fluid" alt="step 1" />
                    </div>

                    <h3>How to Use Trinka Word Add-in for Mac</h3>

                    <div class="history-tl-container">
                        <ul class="tl">
                          <li class="tl-item" ng-repeat="item in retailer_history">
                            <div class="item-title">Login to Trinka in Word Add-in</div>
                            <div class="item-detail">Once the Add-in is loaded successfully. Upgrade to Trinka Premium to get access</div>
                          </li>
                          <li class="tl-item" ng-repeat="item in retailer_history">
                            <div class="item-title">Check for Grammar Errors</div>
                            <div class="item-detail">To get editing, open a new or an existing document click on "open Trinka" icon. As you start writing, Trinka will start detecting errors in your document</div>
                          </li>
                          <li class="tl-item" ng-repeat="item in retailer_history">
                            <div class="item-title">Apply Grammar Corrections</div>
                            <div class="item-detail">
                                <ul class="icon-list">
                                    <li>Click on the detected error correction to apply it. Alternatively, you can click on the alert card to open and view the error details & error category. This will select and highlight the identified error text on the document.</li>
                                    <li>Once you click on the correction the change will get applied.</li>
                                    <li>You can click on the "thumbs down" icon to remove the error correction so it won't be shown again.</li>
                                    <li>You can also click on anywhere on the top section of the card to close the open alert card.</li>
                                </ul>
                                        
                            </div>
                           </li>
                           <li class="tl-item" ng-repeat="item in retailer_history">
                            <div class="item-title">Settings</div>
                            <div class="item-detail">
                                <p>Alert Categories - 4 types of correction alerts are shown.</p>
                                <ul class="icon-list">
                                    <li>Grammar Corrections</li>
                                    <li>Enhancements</li>
                                    <li>Spelling errors</li>
                                    <li>Advisory corrections</li>
                                </ul>
                                <br/>
                                <p>By default, all 4 error categories will be selected. you can deselect it, if you want to filter
                                    the corrections by categories. No. of the total alerts shown will change according to
                                    selection.</p>
                                
                                <p>
                                    <strong>Language</strong> -  you can select between UK English and US English. Alerts will be
                                    refreshed and shown according to the selection.
                                </p>

                                <p>
                                    <strong>Style Guide</strong> - you can select any style guide from the drop down. Alerts will be refreshed
                                    and shown according to the selection.
                                </p>

                                        
                            </div>
                           </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </section> -->

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>よくあるご質問</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Macで使っているWordにTrinkaアドインをインストールするためのシステム要件は何ですか？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p class="mb-2">オペレーティングシステムが「OS X v10.10」、「Yosemite」以降のものであり、Word for Macのバージョンが15.18（160109）以降のものである必要があります。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionNine">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionNineContent" aria-expanded="true" aria-controls="QuestionNineContent">
                                        Mac版MS Word用Trinkaアドインの使い方を教えてください。</a>
                                </div>

                                <div id="QuestionNineContent" class="collapse" aria-labelledby="QuestionNine" data-parent="#faq">
                                    <div class="card-body">
                                        <div class="history-tl-container">
                                            <ul class="tl">
                                              <li class="tl-item" ng-repeat="item in retailer_history">
                                                <div class="item-title">WordのアドインからTrinkaにログイン</div>
                                                <div class="item-detail">アドインが正常にインストールされたら、Wordのメニューバーに追加されたTrinkaタブをクリックして「Open Trinka」をクリック、Trinkaプレミアムアカウントへのログイン情報を入力して「LOG IN」を押してください。ベーシックプランをご利用の方は、プレミアムプランにアップグレードしてからアクセスしてください。</div>
                                              </li>
                                              <li class="tl-item" ng-repeat="item in retailer_history">
                                                <div class="item-title">文法ミス等のチェック</div>
                                                <div class="item-detail">校正を始めるには、新規または既存のドキュメントを開き、Wordのメニューバーにある「Open Trinka」のアイコンをクリック。英文入力を始めると、Trinkaが文書内で修正が必要な箇所をリアルタイムで検出し始めます。</div>
                                              </li>
                                              <li class="tl-item" ng-repeat="item in retailer_history">
                                                <div class="item-title">文法修正の反映</div>
                                                <div class="item-detail">
                                                    <ul class="icon-list">
                                                        <li>検出されたミスの修正案をクリックし、変更を反映させます。画面右側に表示されるAlertをクリックすると、文書上の対象エラーの文字列がハイライト表示され、ミスの詳細とカテゴリーが表示されます。</li>
                                                        <li>修正箇所をクリックすると、変更が適用されます。</li>
                                                        <li>親指を下に向けた手のアイコンをクリックすると、修正提案が削除され、再度表示されることはありません。</li>
                                                        <li>Alert表示枠右上の矢印をクリックすると、Alert表示を開いたり閉じたりできます。</li>
                                                    </ul>
                                                            
                                                </div>
                                               </li>
                                               <li class="tl-item pb-0" ng-repeat="item in retailer_history">
                                                <div class="item-title">設定</div>
                                                <div class="item-detail">
                                                    <p>修正カテゴリー：4種類の修正の区分が表示されます</p>
                                                    <ul class="icon-list">
                                                        <li>Grammar</li>
                                                        <li>Spelling</li>
                                                        <li>Writing Advisor</li>
                                                        <li>Enhancements</li>
                                                    </ul>
                                                    <br/>
                                                    <p>デフォルトでは、4つの修正区分がすべて選択されています。カテゴリごとに修正箇所を絞り込みたい場合は、画面右上にある「Alerts」横にあるフィルターのアイコンをクリックして、選択を解除してください。表示されるアラートの数は、選択内容に応じて変化します。</p>
                                                    
                                                    <p class="mt-20 mb-20">
                                                        <strong>言語 </strong>-  イギリス英語とアメリカ英語のいずれかをお選びください。アラートは、選択内容に応じて更新され表示されます。
                                                    </p>
                    
                                                    <p class="mb-0">
                                                        <strong>スタイルガイド</strong> - 画面上部にあるプルダウンダウンから任意のスタイルガイドを選択できます。スタイルガイドの選択を変えると、原稿内の修正箇所は更新されます。
                                                    </p>   
                                                </div>
                                               </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent"> Word for Mac版のTrinkaアドインを使えば、リアルタイムでスペルや文法をチェックできますか？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい、 Word for Mac版のTrinkaアドインは、リアルタイムで英文をチェックして修正案を提案します。変更を加えた箇所についてもすぐに再チェックし、さらなる修正が必要な場合は新たな提案を行います。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        修正提案を原稿にどうやって反映させるのですか？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>提案の承諾・拒否はいずれも簡単です。提案を承諾する（原稿内に反映させる）場合は提案された単語をクリックし、拒否する（原稿内に反映させない）場合は親指を下に向けた手のアイコンをクリックするだけです。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Mac版MS Word用Trinkaアドインでは、アメリカ英語での校正とイギリス英語での校正を切り替えられますか？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。メニューの「Language Check and Settings」から、アメリカ英語とイギリス英語を切り替えることができます。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        Mac版MS Word用Trinkaアドインで、学術論文のスタイルガイドを選択することはできますか？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。メニューの「Setting」から、スタイルガイドを選択することができます。
                                        </p>
                                    </div>
                                </div>
                            </div>


                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        インストールしたはずのアドインが自分のMacに見つからない場合、どうすればよいですか？
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>システムやご所属機関のセキュリティ設定により、アドインが無効になることがあります。システム管理者に連絡して、WordからTrinkaアドインを利用できるよう依頼してください。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true"
                                        aria-controls="QuestionEightSectionContent">
                                        Mac版MS Word用のTrinkaアドインが英文のミスを検出しません。どうすればよいですか？
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>原因として複数の問題が考えられます。</p><Br/>
                                        <ul>
                                            <li>インターネット接続。Trinkaがエラーを検出し、修正を提案するためには、インターネットに接続されている必要があります。</li>
                                            <li>セキュリティ設定。システム/ご所属機関のセキュリティ設定により、アドインが無効化されていないか確認してください。
                                            </li>
                                            <li>サーバーの負荷。Trinkaのサーバーに過度な負荷が掛かっている可能性がありますので、しばらくお待ちいただくか、時間をあけて再度お試しください。</li>
                                            <li>上記が原因ではなかった場合、Trinkaアドインを削除し、再インストールしてみてください。</li>
                                        </ul>
                                        <p>それでも問題が解決しない場合は、<a href="mailto:support@trinka.ai" class="text-link">support@trinka.ai</a> までメールにてお問い合わせください。</p>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">もっとあります
                            Trinkaの使い方</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="cloud - 文法 チェック">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <!-- <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Others_App_MSWord.svg" alt="ms word - 文法 チェック">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li> -->
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/other_Apps_browser.svg" alt="browser - 文法 チェック">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_Apps_enterprise.svg" alt="enterprise - 文法 チェック">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/cTo16u94rxc"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>